import { useTranslation } from 'react-i18next';
import type { TranslationKey } from '@/types/i18n.types';

/**
 * Custom hook for translations with type safety
 * @returns Translation function with TypeScript support
 */
export const useI18n = () => {
  const { t, i18n } = useTranslation();

  // Type-safe translation function
  const translate = (key: TranslationKey, options?: any) => {
    return t(key, options);
  };

  return {
    t: translate,
    language: i18n.language,
    changeLanguage: i18n.changeLanguage,
    i18n,
  };
};
